import React from 'react';
import { connect } from 'dva';
import _ from 'lodash';
import { getMapStateToProps } from '@/utils/utils';
import { router } from 'umi';
import { Button, Badge, Icon } from 'antd';
import styles from './style.less';
import classNames from 'classnames';

const Index: React.FC<any> = (props: any) => {
  const {
    dispatch,
    ca: { currentCart, currentCartStatus, currentCartTotalItemNumber },
    helper: { tx },
    className,
  } = props;

  const hasCurrentCart = currentCart && currentCart.cartId ? true : false;
  const isCurrentCartGroup =
    currentCart.cartType === 'group' && currentCartStatus.status === 'unconfirmed' ? true : false;

  const cartIconStyle = classNames(styles.cartIcon, className, {
    [styles.cartIconColor]: !isCurrentCartGroup,
    [styles.cartGroupIconColor]: hasCurrentCart && isCurrentCartGroup,
  });

  const handleGoCartDetail = () => {
    router.push('/ca/cart');
  };

  return (
    <span className={styles.cartButton}>
      <Badge count={currentCartTotalItemNumber}>
        <Button
          className={cartIconStyle}
          type="primary"
          shape="circle"
          onClick={handleGoCartDetail}
        >
          <Icon type="shopping-cart" className={styles.icon} />
        </Button>
      </Badge>
    </span>
  );
};

export default connect(getMapStateToProps(['loading', 'ca']))(Index);
